type FhirVersion = 'STU3' | 'R4' | 'R5';

type FhirPrimitiveTypes =
  | 'base64Binary'
  | 'boolean'
  | 'code'
  | 'date'
  | 'dateTime'
  | 'decimal'
  | 'id'
  | 'instant'
  | 'integer'
  | 'markdown'
  | 'oid'
  | 'positiveInt'
  | 'string'
  | 'time'
  | 'unsignedInt'
  | 'uri'
  | 'uuid'
  | 'xhtml';

type FhirPrimitiveValue = {
  value: any;
  type: FhirPrimitiveTypes
};

export type {
  FhirVersion,
  FhirPrimitiveValue,
};
